import { create } from 'zustand'

export type HeaderActions =
  | 'campaign-module:new-actioning'
  | 'campaign-module:new-campaign'

type HeaderActionStore = {
  action: HeaderActions | undefined
  setAction: (action: HeaderActions | undefined) => void
}

export const useHeaderAction = create<HeaderActionStore>((set) => ({
  action: undefined,
  setAction: (action) => set({ action }),
}))
